//============================================================================
// Name        : last_calculated.ts
// Purpose     : Keep the "Last Update ... ago" label on the compare page live
// Created     : 2026-07-31
// Author      : Senitron Team
// Copyright   : Copyright 2026 Senitron Corporation. All rights reserved.
//============================================================================

import { InitPageStrict } from "../index";

class LastCalculated {
  el: HTMLElement;
  calculatedAt: number;
  timer: number;

  constructor(el: HTMLElement) {
    this.el = el;
    this.calculatedAt = Date.parse(el.dataset.calculatedAt);
    if (isNaN(this.calculatedAt)) {
      return;
    }

    this.render();
    this.timer = window.setInterval(() => { this.render(); }, 1000);
  }

  render() {
    const text = this.label();
    if (this.el.textContent !== text) {
      this.el.textContent = text;
    }
  }

  label() {
    const seconds = Math.max(Math.round((Date.now() - this.calculatedAt) / 1000), 0);
    if (seconds < 60) {
      return `${this.pluralize(seconds, "second")} ago`;
    }
    if (seconds < 3600) {
      return `${this.pluralize(Math.floor(seconds / 60), "minute")} ago`;
    }
    return `${this.pluralize(Math.floor(seconds / 3600), "hour")} ago`;
  }

  pluralize(count: number, unit: string) {
    return `${count} ${unit}${count === 1 ? "" : "s"}`;
  }
}

export function LoadPage() {
  ["compare_v2", "compare_v2_details", "compare_v2_summary"].forEach((action) => {
    InitPageStrict(`lightspeed ${action}`, () => {
      document.querySelectorAll("[data-calculated-at]").forEach((el) => {
        new LastCalculated(el as HTMLElement);
      });
    });
  });
}
